import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlServerApiUtils } from '../utils/server-api-utils';
import { ContextApplication } from 'src/app/Context/contextapplication/contextapplication';

@Injectable({ providedIn: 'root' })
export class BaseAPIService {
  constructor(public httpClient: HttpClient,
              public contextApplication: ContextApplication) { }
}

@Injectable({ providedIn: 'root' })
export class APISCockpit extends BaseAPIService {
  private UrlserverUtils = new UrlServerApiUtils(this.contextApplication);

  getDataInfo(url: string) {
    return this.httpClient.get<GenericResultsApi>(this.contextApplication.Server.apiServer + url,
      { headers: this.UrlserverUtils.getHeaderOptions() }).toPromise();
  }

  getDataInfoObservable(url: string) {
    return this.httpClient.get<GenericResultsApi>(this.contextApplication.Server.apiServer + url,
      { headers: this.UrlserverUtils.getHeaderOptions() });
  }

  getDataInfoPromisse(url: string): Promise<any> {
    return this.httpClient
      .get<GenericResultsApi>(this.contextApplication.Server.apiServer + url,
        { headers: this.UrlserverUtils.getHeaderOptions() })
      .toPromise()
      .then((result: any) => {
        return result;
      })
      .catch((e) => console.log('Erro acessar serviço', e));
  }

  getDataInfoPaginated(url: string, params: HttpParams) {
    return this.httpClient.get<GenericResultsApi>(this.contextApplication.Server.apiServer + url,
      { headers: this.UrlserverUtils.getHeaderOptions(), params }).toPromise();
  }

  authenticate(userName: string, password: string, url: string) {
    this.contextApplication.Usuario.username = userName;
    this.contextApplication.Usuario.password = password;
    return this.httpClient.post(this.contextApplication.Server.apiServer + url,
      { userName, password }, { headers: this.UrlserverUtils.getHeaderOptions(), observe: 'response' });
  }

}

export class GenericResultsApi {
  public hasNext: boolean;
  public total: number;
  public items: any[];

  public errorList: ErroGraphicResultsApi[];

}

export class ErroGraphicResultsApi {
  public idGraphic: number;
  public message: string;

}
